import { Button, Card, Flex, Heading, Text, TextField } from "@radix-ui/themes";
import { useAppDispatch, useAppSelector } from "../../store";
import { login } from "../../store/slices/authSlice";
import { useNavigate, useSearchParams } from "react-router-dom";

export function Login() {
  const dispatch = useAppDispatch();
  const isPending = useAppSelector((state) => state.auth.loading === "pending");
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  return (
    <Flex justify="center" align="center" className="flex w-full h-screen">
      <Card className="min-w-[300px] max-w-[400px] p-4 shadow-lg" asChild>
        <form
          onSubmit={async (e) => {
            e.preventDefault();

            const formData = new FormData(e.target as HTMLFormElement);

            const username = formData.get("username") as string;
            const password = formData.get("password") as string;

            if (login && password) {
              dispatch(login({ username, password }))
                .unwrap()
                .then(() => {
                  navigate(searchParams.get("redirect") || "/stores");
                });
            }
          }}
        >
          <Heading mb="4">Sign In</Heading>
          <Text weight="medium" className="mb-2" size="1" asChild>
            <label htmlFor="username">Username</label>
          </Text>
          <TextField.Root
            className="mb-3"
            id="username"
            name="username"
            placeholder="Enter username"
          ></TextField.Root>
          <Text weight="medium" className="mb-2" size="1" asChild>
            <label htmlFor="password">Password</label>
          </Text>
          <TextField.Root
            className="mb-3"
            id="password"
            name="password"
            type="password"
            placeholder="Enter password"
          ></TextField.Root>

          <Flex justify="end">
            <Button disabled={isPending} type="submit">
              Sign in
            </Button>
          </Flex>
        </form>
      </Card>
    </Flex>
  );
}
